export default {"src":"/_next/static/media/wind-speed.e799b87c.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};